export default __webpack_public_path__ + "static/media/home-decor-img-11.eb036a79.jpg";